<template>
  <div>
    <div v-if="rankingBalanceHistorySeries">
      <v-flex
        xs12
        md12
        mt-3
      >
        <span class="block-header">{{
          $t("rankings.taderBalanceHistory")
        }}</span>
        <v-row
          class="dates-toolbar"
          align="end"
          justify="end"
        >
          <v-col
            cols="4"
            sm="4"
            md="2"
          >
            <v-menu
              v-model="PickerFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="fromDate"
                  :label="$t('globals.from')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="params.fromDate"
                :locale="$i18n.locale"
                min="2017-05-01"
                :max="params.toDate || $moment().format('YYYY-MM-DD')"
                @input="PickerFrom = false"
                @change="reload(params.fromDate, 'fromDate')"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="4"
            sm="4"
            md="2"
          >
            <v-menu
              v-model="PickerTo"
              :close-on-content-click="false"
              :nudge-right="40"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="toDate"
                  :label="$t('globals.to')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="params.toDate"
                :locale="$i18n.locale"
                :min="params.fromDate || '2017-05-01'"
                :max="$moment().format('YYYY-MM-DD')"
                @input="PickerTo = false"
                @change="reload(params.toDate, 'toDate')"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-flex>
      <line-chart
        ref="chart"
        :chartdata="chartData"
        :chartoptions="chartOptions"
        :styles="ChartStyles"
      />
    </div>
    <div
      v-if="!$apollo.loading && rankingBalanceHistorySeries == null"
      class="not-found"
    >
      <v-icon>mdi-ghost</v-icon>
      <p>Performance data is not avaliable yet</p>
    </div>
  </div>
</template>

<script>
import LineChart from "@/charts/Line.vue";
import { setTimeout } from "timers";

const RANKING_BALANCE_SERIES_QUERY = require("@/graphql/queries/RankingBalanceHistorySeries.gql");

export default {
  name: "TraderBAlanceChart",
  components: {
    LineChart
  },
  props: {
    projectId: {
      type: String,
      required: true
    },
    baseCurrency: {
      type: String,
      default: "BTC"
    }
  },
  data() {
    return {
      name: "BalanceChart",
      PickerFrom: null,
      PickerTo: null,
      nodata: true,
      params: {
        id: this.$route.params.id,
        fromDate: this.$moment()
          .subtract(180, "days")
          .format("YYYY-MM-DD HH:mm:ss"),
        toDate: this.$moment().format("YYYY-MM-DD HH:mm:ss")
      }
    };
  },
  computed: {
    fromDate() {
      return this.$moment(this.params.fromDate).format("ll");
    },
    toDate() {
      return this.$moment(this.params.toDate).format("ll");
    },
    ChartStyles() {
      return {
        height: `300px`,
        position: `relative`
      };
    },
    chartData() {
      return {
        labels: this.rankingBalanceHistorySeries.labels,
        datasets: [
          {
            label: "Balance",
            data: this.rankingBalanceHistorySeries.datasets,
            meta: this.rankingBalanceHistorySeries.meta,
            backgroundColor: "rgba(111, 220, 255, 0.37)"
          }
        ],
        translate: this.translate,
        base_currency: this.baseCurrency,
        format: this.$options.filters.formatMoney
      };
    },
    chartOptions() {
      return {
        legend: false,
        maintainAspectRatio: false,
        elements: {
          line: {
            borderColor: "#0436af",
            borderWidth: 1.4,
            tension: 0
          }
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              let txn_type = data.translate(data.datasets[0].meta[tooltipItem.index]);
              return data.format(tooltipItem.value) +  ' ' + data.base_currency + ` (${txn_type})`
            },
            title: function(tooltipItem, chart) {
              return tooltipItem[0].label + ", " + chart.datasets[0].label;
            }
          }
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: true,
                color: "#f6f8f9"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                autoSkip: true,
                autoSkipPadding: 20,
                maxRotation: 0,
                callback: function(value, index, values) {
                  return value.substring(0, value.length - 6);
                }
              }
            }
          ]
        }
      };
    }
  },
  methods: {
    translate(value) {
      return this.$t('accounts.' + value)
    },
    changeSeries(data) {
      this.chartdata = {
        labels: data.labels,
        datasets: [
          {
            data: data.datasets
          }
        ]
      };

      if (this.$refs.chart !== undefined) {
        setTimeout(() => {
          this.$refs.chart.render();
        }, 200);
      }
    },
    filterColors(values) {
      let colors = [];
      values.forEach(item => {
        colors.push(item > 0 ? "#75b211" : "#d94040");
      });
      return colors;
    },
    reload(value, from) {
      this.params[from] = value;
      this.params.fromDate = this.$moment(this.params.fromDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.params.toDate = this.$moment(this.params.toDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.$apollo.queries.rankingBalanceHistorySeries.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          this.changeSeries(fetchMoreResult);
          return fetchMoreResult;
        }
      });
    }
  },
  apollo: {
    rankingBalanceHistorySeries: {
      query: RANKING_BALANCE_SERIES_QUERY,
      variables() {
        this.params.project_id = this.projectId;
        return this.params;
      },
      result(data) {
        if (data.loading == false) {
          this.changeSeries(data.data.rankingBalanceHistorySeries);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.performance_note {
  margin: 8px 8px 0;
  display: block;
  color: #7f97ab;
  font-size: 0.78rem;
  i {
    font-size: 0.95rem;
  }
}
</style>
